import { render, staticRenderFns } from "./GoodsInfoSelect.vue?vue&type=template&id=09a3ca06&scoped=true&"
import script from "./GoodsInfoSelect.vue?vue&type=script&lang=js&"
export * from "./GoodsInfoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a3ca06",
  null
  
)

export default component.exports